export const appLoaderType = {
    ENABLE: "LOADER_ENABLE",
    DISABLE: "LOADER_DISABLE"
}

export const authenType = {
    REQUEST: "AUTHEN_REQUEST",
    SUCCESS: "AUTHEN_SUCCESS",
    FAIL: "AUTHEN_FAIL",
    AUTHENTICATE: "AUTHEN_AUTHENTICATE",
    SIGN_OUT_REQUEST: "AUTHEN_SIGN_OUT_REQUEST",
    SIGN_OUT_SUCCESS: "AUTHEN_SIGN_OUT_SUCCESS",
    UPDATE_PROFILE: 'AUTHEN_UPDATE_PROFILE'
}

export const previewActions = {
	BANNER_PREVIEW_ADD: 'BANNER_PREVIEW_ADD',
	BANNER_PREVIEW_CLEAR: 'BANNER_PREVIEW_CLEAR',
    SERVICE_LINK_PREVIEW_ADD: 'SERVICE_LINK_PREVIEW_ADD',
	SERVICE_LINK_PREVIEW_CLEAR: 'SERVICE_LINK_PREVIEW_CLEAR',
    HIGHLIGHT_BOX_PREVIEW_ADD: 'HIGHLIGHT_BOX_PREVIEW_ADD',
	HIGHLIGHT_BOX_PREVIEW_CLEAR: 'HIGHLIGHT_BOX_PREVIEW_CLEAR',
    NOTIFICATION_PREVIEW_ADD: 'NOTIFICATION_PREVIEW_ADD',
	NOTIFICATION_PREVIEW_CLEAR: 'NOTIFICATION_PREVIEW_CLEAR',
    MAIN_CONTENT_PREVIEW_ADD: 'MAIN_CONTENT_PREVIEW_ADD',
	MAIN_CONTENT_PREVIEW_CLEAR: 'MAIN_CONTENT_PREVIEW_CLEAR',
    TEMPLATE_PREVIEW_ADD: 'TEMPLATE_PREVIEW_ADD',
	TEMPLATE_PREVIEW_CLEAR: 'TEMPLATE_PREVIEW_CLEAR',
    MENU_PREVIEW_ADD: 'MENU_PREVIEW_ADD',
	MENU_PREVIEW_CLEAR: 'MENU_PREVIEW_CLEAR',
};

export const chatActions = {
    CHAT_COUNT_READABLE: 'CHAT_COUNT_READ'
}